import React from 'react';
import About from '../assets/About us.png';
import Mission from '../assets/ggmisson.jpg';
import ProfilePic from "../assets/Profile.jpg";
import Footer from '../footer'
import Navigation from '../navbar'
import { useNavigate } from 'react-router-dom';
import Financial21 from '../assets/2021.png'
import Financial25 from '../assets/2025.png'
import Financial23 from '../assets/2023.png'
import Financial24 from '../assets/2024.png'
import Financial22 from '../assets/2022 .png'
import Financials23 from '../documents/Signed 2023 Audited Financial Statement.pdf'
import Financials22 from '../documents/GNGC 2022 Signed Financial Statements_signed.pdf'
import Financials24 from '../documents/2024 Annual Report and Financial Statements.pdf'
import Financials21 from '../documents/2021 Financial Statements.pdf'
import Financials25 from '../documents/2025 Financial Statements.pdf'


function Profile() {

  let navigate = useNavigate();

  const MV = () => {
    navigate("/mission")
  }

  const Prof = () => {
    navigate("/profile")
  }

  return (
    <>
      <Navigation />
      <div className="relative">
        <div className="absolute inset-0 bg-black bg-opacity-50 flex">
          <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

          </h1>
        </div>
        <img
          className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
          src={About}
          alt="Ghana Gas GPP"
        />
      </div>
      <div>

        <h1 className="font-fjalla text-gasblue text-2xl phone:p-4 xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px]">
          Financial Reports
        </h1>

        <div class="grid grid-cols-4 gap-5 m-20">

        <div>
            <a href={Financials25} target="_blank">
              <img src={Financial25} alt="Financial23" />
            </a>
          </div>
          <div>
            <a href={Financials25} target="_blank">

              <h1 className='font-fira text-[17px] md:text-3xl m-6'>2025  Annual Report & Financial Statements</h1>
            </a>
          </div>

          <div>
            <a href={Financials24} target="_blank">
              <img src={Financial24} alt="Financial23" />
            </a>
          </div>
          <div>
            <a href={Financials24} target="_blank">

              <h1 className='font-fira text-[17px] md:text-3xl m-6'>2024  Annual Report & Financial Statements</h1>
            </a>
          </div>

          <div>
            <a href={Financials23} target="_blank">
              <img src={Financial23} alt="Financial23" />
            </a>
          </div>
          <div>
            <a href={Financials23} target="_blank">

              <h1 className='font-fira text-[17px] md:text-3xl m-6'>2023  Annual Report & Financial Statements</h1>
            </a>
          </div>


          <div>
            <a href={Financials22} target="_blank">
              <img src={Financial22} alt="Financial22" />
            </a>
          </div>
          <div>
            <a href={Financials22} target="_blank">
              <h1 className='font-fira text-[17px] md:text-3xl m-6'>2022  Annual Report & Financial Statements</h1>
            </a>
          </div>

          <div>
            <a href={Financials21} target="_blank">
              <img src={Financial21} alt="Financial22" />
            </a>
          </div>
          <div>
            <a href={Financials21} target="_blank">
              <h1 className='font-fira text-[17px] md:text-3xl m-6'>2021  Annual Report & Financial Statements</h1>
            </a>
          </div>
        </div>


        <div className="relative hover:cursor-pointer" onClick={Prof}>
          <div className="absolute inset-y-0 inset-x-1/2 left-0 bg-black bg-opacity-50 flex">
            <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
              Profile
            </h1>
          </div>
          <img
            className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:"
            src={ProfilePic}
            alt="Ghana Gas GPP"
          />
        </div>

        <div className="relative hover:cursor-pointer" onClick={MV}>
          <div className="absolute inset-y-0 inset-x-1/2 right-0 bg-black bg-opacity-50 flex">
            <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mt-30 xl:ml-30">
              Mission & Vision
            </h1>
          </div>
          <img
            className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[400px] xl:w-full xl:"
            src={Mission}
            alt="Ghana Gas GPP"
          />
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Profile;
